import React from 'react'
import banner from '../../../assets/pictures/bannerClinics.png'
import clinic from '../../../assets/images/clínicas.png'

const BannerClinics = () => {
  return (
    <div className='contain-banner-specialist'>
        <img src={banner} alt="" />
        <div className='effect-black-specialist'>
            <section className='text-Banner-specialist'>
               <img src={clinic} alt="clinics" />
               <p>Selecciona el hospedaje en cualquier lugar del mundo, descansa como en casa.</p>
            </section>
        </div>
    </div>
  )
}

export default BannerClinics